import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledWarningButton = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px',
  borderRadius: '50%',
  '&:hover': {
    backgroundColor: COLOR.backgroundWarning,
  },
});

export const StyledPopoverContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const StyledPopoverHeader = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  padding: '12px',
  borderBottom: `0.5px solid ${COLOR.label?.[16] || 'rgba(30, 22, 78, 0.16)'}`,
});

export const StyledPopoverTitle = styled('div')({
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '24px',
  color: COLOR.darkGray || '#1C1C1E',
  letterSpacing: '-0.4px',
});

export const StyledPopoverRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
});

export const StyledPopoverLabel = styled('span')({
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  color: COLOR.darkGray || '#1C1C1E',
  letterSpacing: '-0.4px',
});

export const StyledPopoverValue = styled('span')({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  color: 'rgba(28, 28, 30, 0.64)',
  letterSpacing: '-0.4px',
});

export const StyledCurrentValue = styled('span')({
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  color: '#FF3B30',
  letterSpacing: '-0.4px',
});

export const StyledMaxValue = styled('span')({
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  color: '#16B364',
  letterSpacing: '-0.4px',
});

export const StyledDot = styled('div')({
  width: '4px',
  height: '4px',
  borderRadius: '50%',
  backgroundColor: 'rgba(28, 28, 30, 0.64)',
  flexShrink: 0,
});

export const StyledPopoverDescription = styled('div')({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  color: COLOR.darkGray || '#1C1C1E',
  letterSpacing: '-0.4px',
  padding: '12px',
});

export const StyledBtnRow = styled('div')({
  padding: '0 12px 12px 12px',
});
